import React, { useState } from "react"
import styled from "styled-components"
import Mail from "../../assets/images/mail.png"
import colors from "../../utils/style/colors.tsx"
import Swal from "sweetalert2"
import emailjs from '@emailjs/browser'

const FormContainer = styled.form`
    display: flex;
    gap: 10px;
    padding: 20px;
    border-radius: 10px;
    width: 100%;
    flex-wrap: wrap;
`

const InputContainer = styled.div`
    width: 49%;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;

    @media (max-width: 768px) {
        width: 100%;
    }
`

const InputContainerTextArea = styled.div`
    width: 93%;
    display: flex;
    flex-direction: column;

    @media (max-width: 768px) {
        width: 100%;
    }
`

const ButtonContainer = styled.div`
    width: 93%;
    display: flex;
    flex-direction: column;

    @media (max-width: 768px) {
        width: 100%;
    }
`

const ButtonImg = styled.div`
    width: 180px;
    align-self: end;
    height: 40px;

    @media (max-width: 1150px) {
        width: 135px;
        height: 30px;
    }
`

const ButtonForm = styled.button`
    width: 100%;
    height: 100%;
    font-size: 22px;
    font-family: "Archivo Black", sans-serif;
    color: ${colors.white};
    background-color: ${colors.dark_red};
    border-radius: 10px;
    border: solid 2px ${colors.black};
    text-shadow: 2px 2px ${colors.black};
    -webkit-text-stroke-color: ${colors.black};
    -webkit-text-stroke-width: 1px;
    cursor: pointer;
    padding-right: 55px;
    transition: all ease 0.3s;
    position: relative;

    &:hover {
        border-radius: 10px;
        box-shadow: 3px 3px ${colors.black};
        transition: all ease 0.3s;
    }

    &:active {
        box-shadow: inset 2px 2px black;
    }

    &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }

    @media (max-width: 1150px) {
        font-size: 16px;
        padding-right: 40px;
    }
`

const ImgMail = styled.img`
    width: 35px;
    position: absolute;
    margin-left: 15px;
    margin-top: 4px;
    cursor: pointer;

    @media (max-width: 1150px) {
        width: 26px;
        margin-left: 12px;
        margin-top: 3px;
    }
`

const FormLabel = styled.label`
    font-size: 18px;
    padding-bottom: 5px;
    font-family: "Archivo Black", sans-serif;

    @media (max-width: 1150px) {
        font-size: 16px;
    }

    @media (max-width: 768px) {
        width: 30%;
        font-size: 14px;
        align-content: center;
    }
`

const Input = styled.input`
    padding: 10px;
    border: 2px solid #000;
    border-radius: 5px;
    font-size: 16px;
    width: 80%;
    background-color: #eec6c6;
    height: 10px;
    font-family: "Archivo", sans-serif;
    color: black;

    @media (max-width: 768px) {
        width: 92%;
    }
`

const TextArea = styled.textarea`
    padding: 10px;
    border: 2px solid #000;
    border-radius: 5px;
    font-size: 16px;
    background-color: #eec6c6;
    color: black;
    font-family: "Archivo", sans-serif;
`

function FormContact() {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        subject: "",
        message: ""
    });
    const [isLoading, setIsLoading] = useState(false);

    // ✅ Configuration EmailJS - TES IDENTIFIANTS
    const SERVICE_ID = "service_1ta1w2p";
    const TEMPLATE_ID = "template_dolju9a";
    const PUBLIC_KEY = "dD2ULLQlQ2LnBMEmA";

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const resetForm = () => {
        setFormData({
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            subject: "",
            message: ""
        });
    };

    const onSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);

        // Préparer les données pour EmailJS
        const templateParams = {
            name: `${formData.firstName} ${formData.lastName}`,      // Pour {{name}} dans Reply-To
            email: formData.email,                                     // Pour {{email}} dans Reply-To
            from_name: `${formData.firstName} ${formData.lastName}`,  // Pour le template HTML
            from_email: formData.email,                               // Pour le template HTML
            phone: formData.phone || 'Non renseigné',
            subject: formData.subject || 'Pas de sujet',
            message: formData.message
        };

        try {
            // Envoyer l'email via EmailJS
            const response = await emailjs.send(
                SERVICE_ID,
                TEMPLATE_ID,
                templateParams,
                PUBLIC_KEY
            );

            console.log('✅ Email envoyé avec succès:', response);

            Swal.fire({
                title: "Merci !",
                text: "Votre message a été envoyé avec succès. Je vous répondrai dans les plus brefs délais.",
                icon: "success",
                confirmButtonColor: colors.dark_red
            });
            
            resetForm();
        } catch (error) {
            console.error('❌ Erreur EmailJS:', error);
            Swal.fire({
                title: "Erreur",
                text: "Impossible d'envoyer le message. Veuillez réessayer ou me contacter directement par email à clipweb.info@gmail.com",
                icon: "error",
                confirmButtonColor: colors.dark_red
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <FormContainer onSubmit={onSubmit}>
            <InputContainer>
                <FormLabel htmlFor="firstName">Prénom *</FormLabel>
                <Input 
                    type="text" 
                    id="firstName" 
                    name="firstName" 
                    value={formData.firstName} 
                    onChange={handleChange} 
                    required 
                />
            </InputContainer>

            <InputContainer>
                <FormLabel htmlFor="lastName">Nom *</FormLabel>
                <Input 
                    type="text" 
                    id="lastName" 
                    name="lastName" 
                    value={formData.lastName} 
                    onChange={handleChange} 
                    required 
                />
            </InputContainer>

            <InputContainer>
                <FormLabel htmlFor="email">Email *</FormLabel>
                <Input 
                    type="email" 
                    id="email" 
                    name="email" 
                    value={formData.email} 
                    onChange={handleChange} 
                    required 
                />
            </InputContainer>

            <InputContainer>
                <FormLabel htmlFor="phone">Téléphone</FormLabel>
                <Input 
                    type="tel" 
                    id="phone" 
                    name="phone" 
                    value={formData.phone} 
                    onChange={handleChange} 
                />
            </InputContainer>

            <InputContainer>
                <FormLabel htmlFor="subject">Objet</FormLabel>
                <Input 
                    id="subject" 
                    name="subject" 
                    value={formData.subject} 
                    onChange={handleChange} 
                />
            </InputContainer>

            <InputContainerTextArea>
                <FormLabel htmlFor="message">Message *</FormLabel>
                <TextArea 
                    id="message" 
                    rows="4" 
                    name="message" 
                    value={formData.message} 
                    onChange={handleChange} 
                    required 
                />
            </InputContainerTextArea>

            <ButtonContainer>
                <ButtonImg>
                    <ButtonForm type="submit" disabled={isLoading}>
                        {isLoading ? "Envoi en cours..." : "Envoyer"}
                        {!isLoading && <ImgMail src={Mail} alt="Icon Mail" />}
                    </ButtonForm>
                </ButtonImg>
            </ButtonContainer>
        </FormContainer>
    );
}

export default FormContact;